import { Seo } from "@/components/Seo";
import { Reveal, PageHero } from "@/components/shared";
import { Target, Lock, UserCheck, Gauge, Layers, FlaskConical } from "lucide-react";

const principles = [
  { icon: Target, title: "Partir d'un besoin réel", text: "Identifier d'abord une tâche, une décision ou une information qui ralentit le fonctionnement, avant d'envisager toute technologie." },
  { icon: Lock, title: "Protéger les données", text: "Savoir où circulent les informations de l'entreprise et qui peut y accéder reste une condition préalable à tout usage." },
  { icon: UserCheck, title: "Conserver une validation humaine", text: "Un outil éclaire une décision mais ne la remplace pas. Les étapes sensibles demandent un contrôle humain explicite." },
  { icon: Gauge, title: "Mesurer l'utilité", text: "Un usage se justifie par le temps gagné ou la clarté apportée, pas par sa simple présence dans l'organisation." },
  { icon: Layers, title: "Éviter l'accumulation d'outils", text: "Multiplier les solutions disperse l'attention et complexifie le fonctionnement. La sobriété reste préférable." },
  { icon: FlaskConical, title: "Distinguer expérimentation et mise en production", text: "Tester sur un périmètre restreint permet d'apprendre avant tout déploiement plus large et engageant." },
];

export default function IAOutils() {
  return (
    <>
      <Seo
        title="IA & Outils — BENZENATI"
        description="Comprendre l'intelligence artificielle comme un outil de compréhension et d'organisation pour les PME : une approche prudente, méthodique et maîtrisée."
      />
      <PageHero
        label="IA & Outils"
        title="L'intelligence artificielle comme outil de compréhension et d'organisation"
        intro="L'intelligence artificielle n'est ni une fin en soi ni une promesse abstraite. Pour une PME, elle prend sens lorsqu'elle s'inscrit dans une méthode et répond à un besoin clairement défini."
        testid="ia-hero"
      />

      <section className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-testid="ia-principles">
        <div className="grid grid-cols-1 gap-px overflow-hidden border border-bz-line bg-bz-line md:grid-cols-2 lg:grid-cols-3">
          {principles.map((p, i) => (
            <Reveal key={p.title} delay={(i % 3) * 0.08} className="bg-white">
              <div className="flex h-full flex-col p-10" data-testid={`ia-principle-${i}`}>
                <p.icon size={28} strokeWidth={1.2} className="text-bz-petrol" />
                <h3 className="mt-6 font-serif text-xl text-bz-navy">{p.title}</h3>
                <p className="mt-4 text-base leading-relaxed text-bz-slate">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-16 border-l-2 border-bz-amber bg-bz-ivory2 p-10 lg:p-14" data-testid="ia-callout">
            <p className="font-serif text-2xl leading-snug text-bz-navy lg:text-3xl">
              « Un outil d'intelligence artificielle ne devient utile que lorsqu'il s'intègre dans une méthode, des responsabilités et un objectif clairement défini. »
            </p>
          </div>
        </Reveal>
      </section>
    </>
  );
}
